<template>
<div>
    <img :src="`/icons/${name}.svg`" alt="icon" width="24" height="24" />
</div>
</template>
<script>
export default {
    props: ['name']
}
</script>